import apiClient, { unwrap } from './client';

export const insightsApi = {
  /**
   * Get all insights with optional filtering
   */
  getAll: async (params = {}) => {
    const res = await apiClient.get('/insights', { params: { size: 50, sort: 'insightDate,desc', ...params } });
    const page = unwrap(res);
    return page?.content ?? page ?? [];
  },

  /**
   * Get active insights (last N days)
   */
  getActive: async (daysBack = 7) => {
    const res = await apiClient.get('/insights/active', { params: { daysBack } });
    return unwrap(res) ?? [];
  },

  /**
   * Get insights for a specific date
   */
  getByDate: async (date) => {
    const res = await apiClient.get(`/insights/date/${date}`);
    return unwrap(res) ?? [];
  },

  /**
   * Get insight statistics summary
   */
  getSummary: async (daysBack = 30) => {
    const res = await apiClient.get('/insights/summary', { params: { daysBack } });
    return unwrap(res);
  },

  /**
   * Get single insight by ID
   */
  getById: async (id) => {
    const res = await apiClient.get(`/insights/${id}`);
    return unwrap(res);
  },

  /**
   * Trigger manual insight generation for current tenant
   */
  generate: async () => {
    const res = await apiClient.post('/insights/generate');
    return unwrap(res);
  },

  /**
   * Get unnotified high severity insights (for real-time alerts)
   */
  getUnnotifiedHighSeverity: async () => {
    const res = await apiClient.get('/insights/unnotified');
    return unwrap(res) ?? [];
  },
};
